const DISH_INGREDIENT_USED_FEATURE = {
  INGREDIENT_MATCHER: 'IngredientMatcher',
  PAIRING_PHASE_MATCHER: 'PairingPhraseMatcher',
  AND_ISSUE_MATCHER: 'AndIssueMatcher',
  SPECIAL_CASES_MATCHER: 'SpecialCasesMatcher',
  REFERENCING_WORD_MATCHER: 'ReferencingWordMatcher',
  OR_ISSUE_MATCHER: 'OrIssueMatcher',
  DEFAULT_INGREDIENTS_MATCHER: 'DefaultIngredientsMatcher',
}

export default DISH_INGREDIENT_USED_FEATURE
